import React, { ReactNode, useMemo, useState } from 'react'
import {
  Box,
  Text,
  Button,
  useDisclosure,
  useColorMode,
  Image,
  Heading,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  SimpleGrid,
  GridItem,
} from '@chakra-ui/react'
import PoolDetailItem from './PoolDetailItem'
import PoolDetailBox from './PoolDetailBox'
import { useV2PairsBalance } from 'app/features/trident/migrate/context/useV2PairsBalance'

interface PoolListProps {
  pairsData: {
    pair: {
      token0: {
        id: string
        symbol: string
      }
      token1: {
        id: string
        symbol: string
      }
      id: string
    }
    liquidity: number
    volume1d: number
    volume1w: number
  }[]
}
export default function PoolList({ pairsData }: PoolListProps) {
  const [selectedItem, setSelectedItem] = useState<any>()
  const [open, setOpen] = useState<any>()
  const { loading, pairs } = useV2PairsBalance()
  
  return (
    <>
      <Table variant='simple'>
        <Thead className='first_line_tbl'>
          <Tr className=''>
            <Th align='left'><b>#</b></Th>
            <Th>Token</Th>
            <Th>Liquidity</Th>
            <Th>Volume (24H) </Th>
            <Th>Fees (24H)</Th>
            <Th>APR</Th>
          </Tr>
        </Thead>
        <Tbody className='last_three_tbl'>
          {pairsData ? (
            pairsData.map((pair, index) => (
              <PoolDetailItem
                pair={pair}
                onOpenPool={() => {
                  setSelectedItem(pair)
                  setOpen(true)
                }} />
            ))
          ) : null}
        </Tbody>
      </Table>
      {selectedItem ?
        <PoolDetailBox
          pairData={selectedItem}
          myPairs={pairs}
          isDetailOpen={open}
          onDetailClose={() => {
            setOpen(false)
            setSelectedItem(undefined)
          }}
        />
        : <></>}
    </>
  )
}